import axios from "axios"

  export default {
    callOut(qOpts, afterSucess, afterFail) {
      axios
        .post("/services/silo_search.json", qOpts)
        .then((rep) => {
          afterSucess(rep)
        })
        .catch((error) => {
          console.log(error)
          afterFail(error)
        })
    },
  }
